export default __webpack_public_path__ + "static/three-workers-d978e43bed59ad0cca085d708cc92650.jpg";